import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'percent-badge',
  templateUrl: './percent-badge.component.html',
  styleUrls: ['./percent-badge.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PercentBadgeComponent implements OnInit {

  @Input()
  title: string = 'Save up to';
  @Input()
  titleBottom: string = 'Back';
  @Input()
  percentRate: string = '';
  @Input()
  resortCreditApplied: Number = 0;
  @Input()
  cssClass: string = "";
  constructor() { }
  @Input()
  titlePlacement: string= "top";

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/percent-badge/percent-badge.component.ts